// Okta
export const OKTA_CLIENT_ID = "0oaffwfuth6ic5sfd5d7"
export const OKTA_ISSUER = "https://17live.okta.com"
export const API_HOST = "https://shot-api-prod.17app.co"
